import {navigateTo, router, type RouterState} from 'yrv';

export const replaceStateWithQuery = (query: Record<string, unknown>) => {
  let routerState: RouterState | undefined;
  router.subscribe(value => {
    if (!value.initial) {
      routerState = value;
    }
  });

  if (!routerState) {
    return;
  }

  const {path, params} = routerState;

  // Remove nullish and empty parameters
  const queryParams = Object.fromEntries(
    Object.entries(query).filter(
      ([_, value]) =>
        value != null && value !== '' && (!Array.isArray(value) || value.length)
    )
  );

  // Add query parameters to current router state
  navigateTo(path, {replace: true, params, queryParams});
};
